import React, { useState } from "react";
import { FormControl, FormGroup } from "react-bootstrap";
import Link from "next/link";
import { useRouter } from "next/router";
import { useAppContext } from "../../../../_context";
import HideIcon from "../../../Icons/ic_hide.svg";
import ShowIcon from "../../../Icons/ic_show.svg";
import CustomInput from "../../../Misc/CustomInput";
import Button from "../../../Misc/Button";
import { apiUrl } from "../../../../utilities/Helpers";
import { useUserContext } from "../../../../_contextUser";
import { errorMessages } from "../../Premium/helpers/constants";
import { storageKeys } from "../../../../utilities/storageKeys";

function LoginForm() {
  const [{ tx }] = useAppContext();
  const router = useRouter();

  const [emailValue, setEmailValue] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [_, setUserContext] = useUserContext();

  const onLoginSubmit = async (e) => {
    e.preventDefault();

    if (!emailValue || !password) {
      setErrorMessage(tx["Please fill in all the inputs"]);
      return;
    }

    const payload = {
      email: emailValue,
      password,
    };

    setIsLoading(true);
    try {
      const res = await fetch(apiUrl("/api/v1/users/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-version": "New",
        },
        body: JSON.stringify(payload),
      });
      const formattedResponse = await res.json();

      if (formattedResponse?.token) {
        sessionStorage.setItem(
          storageKeys.loggedUserToken,
          formattedResponse?.token,
        );
        setUserContext((prev) => {
          return {
            ...prev,
            idUser: formattedResponse?._id,
            userLoginToken: formattedResponse?.token,
            userDeactivated: formattedResponse?.deactivated,
          };
        });
        router.push(`/find-tennis-partner/player/${formattedResponse._id}`);
      }

      if (formattedResponse.message === errorMessages.invalidCredentials) {
        setErrorMessage(tx["Email or password is incorrect."]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <div className="px-md-5 py-5">
      <h2 className="mb-4">{tx["Log in to your account"]}</h2>
      <form onSubmit={onLoginSubmit}>
        <FormGroup className="mb-3">
          {errorMessage && (
            <div
              className="rounded py-2 px-3 mb-3"
              style={{ backgroundColor: "rgba(255, 56, 53, 0.1)" }}>
              <small className="text-red-1 mb-0">{errorMessage}</small>
            </div>
          )}
          <label className="form-label" htmlFor="cancelation-email">
            {tx["Email"]}
          </label>
          <FormControl
            id="cancelation-email"
            value={emailValue}
            onChange={(e) => setEmailValue(e.target.value)}
          />
        </FormGroup>
        <CustomInput
          id="set-password"
          label={tx["Password"]}
          icon={showPassword ? <ShowIcon /> : <HideIcon />}
          iconClick={() => setShowPassword((prev) => !prev)}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? "text" : "password"}
          className="mb-3"
        />
        <Link href="/find-tennis-partner/reset-password" passHref={true}>
          <a>
            <p className="text-primary text-center fw-bold mb-3">
              {tx["Forgot your password?"]}
            </p>
          </a>
        </Link>

        <Button
          className="w-100 py-0 py-lg-0 px-0 px-lg-0"
          type="submit"
          isLoading={isLoading}>
          {tx["Log in"]}
        </Button>
      </form>
    </div>
  );
}

export default LoginForm;
